var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDrys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 56,
    viewBox: "0 0 128 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4758_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4109 2.89185C29.9409 2.89185 37.7512 10.6753 37.7512 21.3781V23.8641C37.7512 34.5669 29.9409 42.3504 17.4109 42.3504H0.218506V2.89185H17.4131H17.4109ZM26.7421 21.6487C26.7421 16.1884 22.89 12.3495 16.1106 12.3495H11.0664V32.8906H16.1106C22.8921 32.8906 26.7421 29.0517 26.7421 23.5935V21.6487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.266 13.4339V23.6484C61.1821 23.5406 59.6633 23.3778 57.926 23.3778C54.3475 23.3778 52.6102 24.9442 52.6102 30.4045V42.3503H42.0869V13.7024H46.9678L50.4402 22.4583C51.7427 15.3766 55.0518 12.8906 58.5751 12.8906C60.3124 12.8906 61.5045 13.2162 62.2639 13.4318L62.266 13.4339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.049 13.7024H96.4642L86.9717 41.955C83.6096 51.5776 79.276 55.9978 71.8984 55.9978C69.8917 55.9978 67.7769 55.6744 66.4193 55.296V46.1025C67.6666 46.2653 69.0242 46.3731 69.9999 46.3731C72.5496 46.3731 74.2742 44.8997 74.7132 41.843L64.2981 13.7024H75.2542L80.6781 30.9457L86.049 13.7024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.204 33.1633C107.475 34.8925 108.506 36.1355 112.465 36.1355C116.423 36.1355 117.237 35.216 117.237 33.7024C117.237 32.3495 116.37 31.4849 110.403 31.2143C100.422 30.7281 97.493 27.4853 97.493 22.2407C97.493 16.996 101.451 12.8887 112.083 12.8887C122.714 12.8887 126.24 16.9432 126.619 22.7818H116.531C116.368 20.9427 115.392 19.8625 111.919 19.8625C108.447 19.8625 107.418 20.7821 107.418 22.1329C107.418 23.4837 108.286 24.3504 113.981 24.7288C124.233 25.3777 127.271 28.5677 127.271 33.4846C127.271 38.9449 123.257 43.1622 112.03 43.1622C100.802 43.1622 97.3848 39.1605 97.0051 33.1612H107.202L107.204 33.1633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.981 3.56831L91.5155 0V6.49398L69.981 10.0623V3.56831Z",
    fill: "#00C597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 51.007C0 48.1997 1.82636 46.3796 5.02939 46.3796C8.03939 46.3796 9.66 47.9186 9.95697 50.1488H8.7097C8.4403 48.4682 7.26939 47.4303 5.03151 47.4303C2.54758 47.4303 1.21121 48.7641 1.21121 51.0197V51.3537C1.21121 53.6093 2.5497 54.9432 5.03151 54.9432C7.28212 54.9432 8.45303 53.8672 8.7097 52.2246H9.95697C9.66212 54.4548 8.04151 55.9938 5.02939 55.9938C1.82636 55.9938 0 54.1737 0 51.3664L0 51.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4654 55.8647H19.1524L17.9688 53.3005H13.056L11.8724 55.8647H10.5742L14.9482 46.5063H16.0554L20.4676 55.8647H20.4654ZM15.4997 47.9417L13.5312 52.2626H17.4809L15.4997 47.9417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0793 46.5063C29.3702 46.5063 30.4881 47.6098 30.4881 49.1614C30.4881 50.7131 29.3681 51.8144 27.0793 51.8144H23.1678V55.8647H21.9714V46.5063H27.0772H27.0793ZM27.0411 50.7638C28.649 50.7638 29.2684 50.1486 29.2684 49.1614C29.2684 48.1742 28.6511 47.5591 27.0411 47.5591H23.1699V50.7638H27.0411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5108 55.8647H32.3145V46.5063H33.5108V55.8647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3097 47.557V46.5063H44.4819V47.557H40.5067V55.8647H39.2955V47.557H35.3076H35.3097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7833 55.8647H52.4703L51.2866 53.3005H46.3739L45.1903 55.8647H43.8921L48.266 46.5063H49.3733L53.7854 55.8647H53.7833ZM48.8175 47.9417L46.8491 52.2626H50.7988L48.8175 47.9417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2893 55.8647V46.5063H56.4857V54.8141H62.2087V55.8647H55.2893Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4758_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.273,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDrys);
export default __webpack_public_path__ + "static/media/logo-drys.9b20c5df29ae1af77fd08f6b658f6f62.svg";
export { ForwardRef as ReactComponent };